import { render } from "./baseCard.vue?vue&type=template&id=a11d23cc&scoped=true"
const script = {}

import "./baseCard.vue?vue&type=style&index=0&id=a11d23cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11d23cc"]])

export default __exports__